module.exports = __webpack_public_path__ + "img/introduce_elephant.d4d3e825.png";